<template>
  <CDialog
    v-bind="{ show }"
    @close="close"
    :title="$t('saraf_terms_and_conditions')"
    custom-class="!max-w-[765px]"
  >
    <div class="p-5">
      <div
        ref="termsContent"
        class="!overflow-y-scroll custom-scroll h-[500px] pr-2"
      >
        <div class="terms-content" v-html="data?.content" />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import { ref } from "vue";

interface Props {
  show: boolean;
  data?: any;
}
defineProps<Props>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "submit"): void;
}>();

const termsContent = ref();

const close = () => {
  emit("close");
};
</script>
<style>
.terms-content > p {
  margin-bottom: 8px !important;
  font-family: "Inter", sans-serif !important;
}
.terms-content span {
  font-family: "Roboto", sans-serif !important;
}
.terms-content p,
.terms-content li {
  font-family: "Inter", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.terms-content ol,
.terms-content ul {
  padding-left: 16px;
  font-family: "Inter", sans-serif !important;
}
.terms-content ul li {
  list-style: disc;
  position: relative;
  font-family: "Inter", sans-serif !important;
}
.terms-content ol li {
  list-style: auto;
}
.terms-content a {
  color: #16cc53;
}
.terms-content a:hover {
  text-decoration: underline;
}
.terms-content img {
  width: 100%;
  max-height: 438px;
  border-radius: 8px;
}
.terms-content b {
  font-weight: 500;
}

.terms-content h4,
.terms-content h1,
.terms-content h2,
.terms-content h3,
.terms-content h5,
.terms-content h6 {
  font-family: "Inter", sans-serif !important;
  color: #080a15;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-bottom: 12px;
}
</style>
